export class InjectedModule
{
    constructor(routeName:string,module:any)
    {
        this.module=module;
        this.routeName=routeName
    }
    routeName:string
    module:any;
}
     
